/**
 * Resolves a radius input into a valid CSS radius value.
 * @param input - The radius input (`sm`, `md`, `lg`, `full`, `none`, or CSS length).
 * @returns The resolved CSS radius value.
 */
export function resolveRadius(input: string) {
  const map: Record<string, string> = {
    none: '0px',
    sm: 'var(--sky-radius-primary)',
    md: 'var(--sky-radius-secondary)',
    lg: 'var(--sky-radius-tertiary)',
    full: '9999px',
  };
  return Object.prototype.hasOwnProperty.call(map, input) ? map[input] : input;
}
